import React from 'react';

export default function Home({ navigate }) {
  return (
    <div className="screen">
      <div className="home-hero">
        {/* Diamond Logo SVG */}
        <svg className="home-diamond" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <polygon points="100,8 192,100 100,192 8,100" fill="#1a3d20"/>
          <polygon points="100,22 178,100 100,178 22,100" fill="none" stroke="#3aaa52" strokeWidth="3"/>
          {/* Helmet dome */}
          <path d="M74,58 Q68,82 68,98 L68,116 Q70,128 100,130 Q130,128 132,116 L132,98 Q132,82 126,58 Q114,48 100,46 Q86,48 74,58Z" fill="#3aaa52"/>
          {/* Ear guards */}
          <rect x="52" y="70" width="18" height="38" rx="5" fill="#3aaa52"/>
          <rect x="130" y="70" width="18" height="38" rx="5" fill="#3aaa52"/>
          {/* Eye opening */}
          <rect x="76" y="76" width="48" height="18" rx="3" fill="#1a3d20"/>
          {/* Cage top bar */}
          <rect x="68" y="116" width="64" height="8" rx="3" fill="#3aaa52"/>
          {/* Cage body */}
          <path d="M68,124 Q68,148 80,162 Q90,172 100,174 Q110,172 120,162 Q132,148 132,124Z" fill="#1a3d20" stroke="#3aaa52" strokeWidth="3.5"/>
          {/* Cage horizontal bars */}
          <line x1="70" y1="132" x2="130" y2="132" stroke="#3aaa52" strokeWidth="3"/>
          <line x1="72" y1="142" x2="128" y2="142" stroke="#3aaa52" strokeWidth="3"/>
          <line x1="75" y1="152" x2="125" y2="152" stroke="#3aaa52" strokeWidth="3"/>
          <line x1="80" y1="162" x2="120" y2="162" stroke="#3aaa52" strokeWidth="2.5"/>
          {/* Cage vertical bars */}
          <line x1="88" y1="124" x2="84" y2="168" stroke="#3aaa52" strokeWidth="2.5"/>
          <line x1="100" y1="124" x2="100" y2="172" stroke="#3aaa52" strokeWidth="2.5"/>
          <line x1="112" y1="124" x2="116" y2="168" stroke="#3aaa52" strokeWidth="2.5"/>
        </svg>

        <div className="home-ump">UMP</div>
        <div className="home-buddy">BUDDY</div>
        <div className="home-tagline">Real-Time Game Tracker</div>
      </div>

      <div className="home-actions">
        <button className="btn btn-primary btn-lg" onClick={() => navigate('newGame')}>
          ⚾ Start a Game
        </button>
        <button className="btn btn-secondary btn-lg" onClick={() => navigate('join')}>
          👁 Join as Spectator
        </button>
      </div>

      <div style={{ padding: '0 24px', marginTop: 8 }}>
        <div style={{
          background: 'var(--surface)',
          border: '2px solid var(--border)',
          borderRadius: 'var(--radius)',
          padding: '16px 20px',
          fontSize: 13,
          color: 'var(--gray)',
          lineHeight: 1.6
        }}>
          <strong style={{ color: 'var(--green)', display: 'block', marginBottom: 4, letterSpacing: 1 }}>HOW IT WORKS</strong>
          One person tracks the game — ump or volunteer. Everyone else joins with the game code and follows along live. No account needed.
        </div>
      </div>
    </div>
  );
}
